module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAb1BMVEUAAAAktv8iu+4gv+8etOEcvewbtu0bv+0eueoeu+oeueoevOoeuugeuOgeu+geu+sduegdu+seueoeu+oguuseuuoeuusfuuofueoeuukeuuofueofuukfuuofu+ofuukfuukfuuofuuofu+sfuurW5Ka4AAAAJHRSTlMABw8QERscHG1tbm5vcHBwcXGHh4nLy8/R0tLy9vb29/j4+vruUDTCAAAAt0lEQVRIx+1WyxKDIAwMal/UVqpgtcX3/v839oZ4AXppZxj3lpndhCQzWYiiAbvVHRx4K8Fs/uEJL15HK3+DADRrjTswXTPXk7N8AgoTKuDi6/IMKBN0QOITJEBvAgD+QdqkHwqkLolIzvY0l9Ih0NBEpLfz164KfUVEctlUqP7adAyCfXH74vbFBR3jzD7GCuA+AbfPvQBGnrroaT4CYrWsNsSyWvalKZ42tlvUg4s91A8WzyfjA88DUFJNr6+lAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/makeTysonPenHolder/imgs/笔筒属性.png
// module id = C3lB
// module chunks = 2